import api from './api';
import { ApiResponse, PaginatedResponse } from '../types';

export interface SkillLevel {
  _id: string;
  name: string;
  slug: string;
  status: 'active' | 'inactive';
  isDeleted: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSkillLevelData {
  name: string;
  status: 'active' | 'inactive';
}

const skillLevelService = {
  async getActiveSkillLevels(params?: {
    page?: number;
    limit?: number;
  }): Promise<ApiResponse<PaginatedResponse<SkillLevel>>> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    
    const response = await api.get(`/skill-level/active?${queryParams.toString()}`);
    return response.data;
  },

  async createSkillLevel(skillLevelData: CreateSkillLevelData): Promise<ApiResponse<SkillLevel>> {
    const response = await api.post('/skill-level', skillLevelData);
    return response.data;
  }
};

export default skillLevelService;
